import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const ReportesReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Consultar reportes
   */
  builder
    .addCase(Types.CONSULTAR_REPORTES_LOADING, (state) => {
      state.consultarReportesLoading = true;
      state.consultarReportesError = null;
    })
    .addCase(Types.CONSULTAR_REPORTES_SUCCESS, (state, action) => {
      const { consultarReportesData } = action;
      state.consultarReportesData = consultarReportesData;
      state.consultarReportesLoading = false;
      state.consultarReportesError = null;
    })
    .addCase(Types.CONSULTAR_REPORTES_FAILURE, (state, action) => {
      const { consultarReportesError } = action;
      state.consultarReportesData = INITIAL_STATE.consultarReportesData;
      state.consultarReportesLoading = false;
      state.consultarReportesError = consultarReportesError;
    });

  /**
   * Exportar reportes a Excel
   */
  builder
    .addCase(Types.EXPORTAR_REPORTES_EXCEL_LOADING, (state) => {
      state.exportarReportesExcelLoading = true;
      state.exportarReportesExcelError = null;
    })
    .addCase(Types.EXPORTAR_REPORTES_EXCEL_SUCCESS, (state, action) => {
      const { exportarReportesExcelData } = action;
      state.exportarReportesExcelData = exportarReportesExcelData;
      state.exportarReportesExcelLoading = false;
      state.exportarReportesExcelError = null;
    })
    .addCase(Types.EXPORTAR_REPORTES_EXCEL_FAILURE, (state, action) => {
      const { exportarReportesExcelError } = action;
      state.exportarReportesExcelData = INITIAL_STATE.exportarReportesExcelData;
      state.exportarReportesExcelLoading = false;
      state.exportarReportesExcelError = exportarReportesExcelError;
    });

  /**
   * Limpiar datos de reportes
   */
  builder.addCase(Types.LIMPIAR_REPORTES, (state) => {
    state.consultarReportesData = INITIAL_STATE.consultarReportesData;
    state.consultarReportesError = null;
    state.exportarReportesExcelData = INITIAL_STATE.exportarReportesExcelData;
    state.exportarReportesExcelError = null;
  });
});
